"use strict";

/**
 * yandex-links.js — добавление и удаление ссылок на Yandex Disk файлы.
 * HTML элемента берётся с сервера через AJAX.
 */

function initYandexLinks() {
    jQuery(".yandex-links-wrapper").each(function () {
        let container = jQuery(this);
        let list = container.find(".js-yandex-links-list");
        let input = container.find(".js-yandex-link-input");
        let addBtn = container.find(".js-yandex-link-add");
        let field = container.data("field") || "yandex_disk_files";
        let edit = container.find(".js-yandex-link-input").length > 0;

        function extractName(url) {
            let parts = url.split("/");
            let last = parts[parts.length - 1];
            return last || "File";
        }

        // Add link — fetch HTML from server
        addBtn.on("click", function () {
            let url = input.val().trim();
            if (!url) return;

            addBtn.prop("disabled", true);

            jQuery.post('/component/yandex-disk-files/item', {
                _token: jQuery('meta[name="csrf-token"]').attr("content"),
                url: url,
                name: extractName(url),
                field: field,
                edit: edit
            }).done(function (data) {
                list.append(data.html);
                input.val("");
            }).always(function () {
                addBtn.prop("disabled", false);
            });
        });

        // Remove link (delegated)
        list.on("click", ".js-yandex-link-remove", function () {
            jQuery(this).closest(".yandex-link-item").remove();
        });
    });
}

jQuery(document).ready(function () {
    initYandexLinks();
});

window.initYandexLinks = initYandexLinks;
